import { api } from "@helm/core";
import { endSession } from "@helm/ui";

/**
 * The one sign-out every control uses: the top-bar account menu and Settings → Security on
 * desktop, the Account tab on mobile, and the command palette. Ends the server session, then
 * reloads; the app boots to the sign-in screen.
 */
export function signOut(): Promise<void> {
  return endSession({
    logout: api.logout,
    reload: () => {
      location.reload();
    },
  });
}
